import { atom } from 'recoil';

export const SelectPlaceTypeState = atom({
    key: 'SelectPlaceTypeState',
    default: null
});